export const linkStyles = {
	color: 'white',
	marginTop: '24px',
	fontStyle: 'bold',
	fontSize: '16px',
	backgroundColor: 'green',
	padding: '4px',
	borderRadius: '5px'
};

export const buttonStyles = {
	background: 'none',
	border: 'none',
	padding: 0,
	cursor: 'pointer'
};
